<template>
  <div>
    <Card>
      <div slot="title">中标挂网信息</div>
      <Form ref="operatorInfo" :model="operatorInfo" inline :label-width="100" :rules="biddingValidate">
        <FormItem label="中标挂网人员" prop="operator">
          <Input type="text" v-model="operatorInfo.operator"></Input>
        </FormItem>
        <FormItem label="中标挂网日期" prop="biddingDate" required>
          <DatePicker type="datetime" v-model="operatorInfo.biddingDate" format="yyyy-MM-dd HH:mm" placeholder="挂网日期" style="width: 200px"></DatePicker>
        </FormItem>
        <FormItem label="挂网" prop="spreadWeb">
          <Select v-model="operatorInfo.spreadWeb" multiple style="width:300px;position:relative;z-index:20">
            <Option v-for="(item,index) in spreadTypeArr" :value="item.itemName" :key="index">{{ item.itemName }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div style="width:100%;text-align:center;">
        <Button type="primary" @click="submitOperateInfo">确定</Button>
      </div>
    </Card>
    <Card style="margin-top: 10px;">
      <div slot="extra">
        <Button type="primary" size="small" @click="addBiddingArticle">新增公告</Button>
      </div>
      <div slot="title">中标公告挂网</div>
      <Table :columns="biddingArticlesColumns" :data="articles"></Table>
    </Card>
    <Modal class="bidding-modal" v-model="articleEditorVisible" width="1000px" :mask-closable="false" :transfer="status">
      <div slot="header">中标公告编辑</div>
      <articleEditor ref="articleEditor" editorId="e-bidding" :selectArticle="selectArticle" @cancel="articleEditorVisible=false" :projectData="projectData" :articleInfo="operatorInfo" @addSuccess="articleAddSuccess"></articleEditor>
      <div slot="footer">
        <!-- <Button @click="articleEditorVisible=false">取消</Button>
        <Button type="primary">确定</Button> -->
      </div>
    </Modal>
    <Modal class="invite-modal" v-model="showCode" :mask-closable="false" :width="300" style="text-align:center">
      <div slot="header">扫码查看公告详情</div>
      <img :src="'data:image/png;base64,' + qrBase" style="width:200px">
      <p>官网公告详情链接：
        <a :href="'http://www.chinapsp.cn/wxNotice.html?itemid='+articleId" target="blank">
          http://www.chinapsp.cn/wxNotice.html?itemid={{articleId}}
        </a>
      </p>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import articleEditor from './articleEditor'
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import util from '@/lib/util'
import { formatDate, isWeiXin } from '@/lib/tool'

export default {
  components: {
    articleEditor
  },
  props: {
    status: {
      default: true
    },
    projectData: {
      type: Object
    },
    articles: {
      type: Array
    }
  },
  data() {
    return {
      spreadTypeArr: [],
      operatorInfo: {
        operator: '',
        biddingDate: '',
        spreadWeb: ['采联国际'],
      },
      biddingArticlesList: [],
      biddingArticlesColumns: [
        {
          title: '公告名称',
          key: 'title'
        },
        {
          title: '公告时间',
          width: 180,
          render: (h, params) => {
            let time = ''
            if (params.row.creationTime) {
              time = params.row.creationTime.replace('T', ' ').split('.')[0]
            }
            return h('span', time)
          }
        },
        {
          title: '操作',
          width: 300,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.articleId = params.row.id
                    ajax.post('https://api.choicelink.cn/UserCenter/api/TokenAuth/QRCode', {
                      "path": `pages/articlePage/articlePage?itemid=${params.row.id}`,
                      "authProvider": "cailian"
                    }).then(res => {
                      this.showCode = true
                      this.qrBase = res.data.result
                    })
                  }
                }
              }, '二维码/详情链接'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    // 挂网权限
                    if (!this.netButton) {
                      this.$Message.error('无挂网权限')
                      return
                    }
                    this.viewArticle(params.row)
                  }
                }
              }, '查看/编辑'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    if (!this.netButton) {
                      this.$Message.error('无挂网权限')
                      return
                    }
                    this.deleteArticle(params.row)
                  }
                }
              }, '删除')
            ])
          }
        },
      ],
      articleEditorVisible: false,
      biddingValidate: {
        operator: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        // biddingDate: [
        //   { required: true, type: 'date', message: '不能为空', trigger: 'change' }
        // ],
        spreadWeb: [
          { required: true, type: 'array', message: '不能为空', trigger: 'change' }
        ],
      },
      hasSubmit: false,
      selectArticle: {
        id: '',
        articleContentId: '',
        title: '',
        articleContent: ''
      },
      qrBase: '',
      showCode: false,
      articleId: ''
    }
  },
  created() {
    if (this.projectData) {
      this.refreshProject(this.projectData)
    }
    this.getDataDict('挂网地址').then(res => {
      this.spreadTypeArr = res
    })
  },
  computed: {
    netButton() {
      if (this.$store.state.session.roleNames.indexOf('挂网人员') !== -1) {
        return true
      }
      return false
    }
  },
  methods: {
    async getDataDict(type = '', ip = 0, id) {//ip控制是否只查询一级数据
      if (!type) {
        return []
      }
      let para = {}
      if (ip) {
        para = {
          filter: `itemType=="${type}"&&itemParent==""`
        }
      } else {
        para = {
          filter: `itemType=="${type}"`
        }
      }
      if (id) {
        para = {
          filter: `itemType=="${type}"&&itemParent=="${id}"`
        }
      }
      let rep = await ajax.get(requestUrls.AbpDataDict.GetList, {
        params: para
      })
      if (rep.data.success) {
        return rep.data.result.items
      }
      return []
    },
    deleteArticle(row) {
      this.$Modal.confirm({
        title: '公告删除',
        content: `确认删除公告${row.title}`,
        onOk: async () => {
          this.$Spin.show()
          try {
            let rep = await ajax.delete(requestUrls.articles.Delete, {
              params: {
                id: row.id
              }
            })
            this.$Spin.hide()
            if (rep.data.success) {
              this.$Message.success('删除成功')
              this.$emit('refreshArticles')
            } else {
              this.$Message.error('删除失败')
            }
          } catch (err) {
            this.$Spin.hide()
            this.$Message.error('删除失败')
            console.error(err)
          }
        }
      })
    },
    async viewArticle(row) {
      this.$Spin.show()
      try {
        // 获取公告内容
        let rep = await ajax.get(requestUrls.articlesData.GetArticleDataByAIdAsync, {
          params: {
            aId: row.id
          }
        })
        this.$Spin.hide()
        if (rep.data.success) {
          this.selectArticle = row
          this.selectArticle.articleContent = rep.data.result.content
          this.selectArticle.articleContentId = rep.data.result.id
          this.articleEditorVisible = true
        } else {
          this.$Message.error('获取公告信息失败')
        }
      } catch (err) {
        this.$Spin.hide()
        console.error(err)
        this.$Message.error('获取公告信息失败')
      }
    },
    addBiddingArticle() {
      // 限制进入4.0立项
			if (this.projectData.dataSource === '4.0立项') {
				this.$Modal.confirm({
					title: '温馨提示',
					content: '公告功能已转移到采联业务系统4.0，请前往采联业务系统4.0处理。',
					cancelText: '取消',
					okText: '立即前往',
					onOk: () => {
						if (isWeiXin()) {
							window.open('https://qy.choicelink.cn:8440?wxWork=1&tenancyName=clgj&authProvider=CailianBusiness&appName=WorkWeiXin')
						} else {
							window.open('https://qy.choicelink.cn:8440')
						}
					}
				})
				return
			}
      // 挂网权限
      if (!this.netButton) {
        this.$Message.error('无挂网权限')
        return
      }
      // 检查挂网信息填完
      let projectData = this.projectData
      if ((projectData.winNetP && projectData.winTime && projectData.winNet) || this.hasSubmit) {
        this.selectArticle = {
          id: '',
          articleContentId: '',
          title: '',
          articleContent: '',
          isDispaly: true,
          fileDispaly: false,
          endTimeDispaly: false
        }
        this.articleEditorVisible = true
        return
      }
      this.$Message.error('请先填完挂网信息')
    },
    async articleAddSuccess() {
      this.articleEditorVisible = false
      this.$emit('refreshArticles')
      // 挂网成功修改项目状态
      if (this.projectData.projectState !== '项目失败') {
        let rep = await ajax.put(requestUrls.ClProjectDb.UpdateStatus, {
          id: this.projectData.id,
          projectState: '已开评标完'
        })
      }
    },
    submitOperateInfo() {
      this.$refs.operatorInfo.validate(async (valid) => {
        if (valid) {
          if (!this.operatorInfo.biddingDate) {
            this.$Message.error('请输入挂网日期')
            return
          }
          this.$Spin.show()
          try {
            let rep = await ajax.put(requestUrls.ClProjectDb.UpdateWin, {
              id: this.projectData.id,
              winNetP: this.operatorInfo.operator,
              winTime: formatDate(this.operatorInfo.biddingDate),
              winNet: this.operatorInfo.spreadWeb[0],
              winNet2: this.operatorInfo.spreadWeb[1],
              winNet3: this.operatorInfo.spreadWeb[2],
              winNet4: this.operatorInfo.spreadWeb[3]
            })
            this.$Spin.hide()
            if (rep.data.success) {
              this.$Message.success('中标挂网信息提交成功')
              this.hasSubmit = true
              // 挂网成功修改项目状态
              if (this.projectData.projectState !== '项目失败') {
                let statusRep = await ajax.put(requestUrls.ClProjectDb.UpdateStatus, {
                  id: this.projectData.id,
                  projectState: '已开评标完'
                })
              }
            } else {
              this.$Message.error('中标挂网信息提交失败')
            }
          } catch (err) {
            console.error(err)
            this.$Spin.hide()
            this.$Message.error('中标挂网信息提交失败')
          }
        }
      })
    },
    refreshProject(val) {
      this.operatorInfo.operator = val.winNetP
      this.operatorInfo.biddingDate = ''
      if (val.winTime) {
        this.operatorInfo.biddingDate = val.winTime.replace('T', ' ')
      }

      this.operatorInfo.spreadWeb = []
      if (val.winNet) {
        this.operatorInfo.spreadWeb.push(val.winNet)
      }
      if (val.winNet2) {
        this.operatorInfo.spreadWeb.push(val.winNet2)
      }
      if (val.winNet3) {
        this.operatorInfo.spreadWeb.push(val.winNet3)
      }
      if (val.winNet4) {
        this.operatorInfo.spreadWeb.push(val.winNet4)
      }
      if (this.operatorInfo.spreadWeb.length === 0) {
        this.operatorInfo.spreadWeb.push('采联国际')
      }
    }
  },
  watch: {
    projectData(val) {
      this.refreshProject(val)
    },
  }
}
</script>

<style lang="less" scoped>
.bidding-modal {
  .ivu-modal {
    top: 50px;
  }
}
.ivu-select-dropdown {
  top: 33px !important;
}
</style>
